/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Side Gig` - 2 to 4 shifts per month
 * * `Part-time` - 5 to 8 shifts per month
 * * `Full-time` - 9+ shifts per month
 */
export enum WorkTypeEnum {
    SIDE_GIG = 'Side Gig',
    PART_TIME = 'Part-time',
    FULL_TIME = 'Full-time',
}
